import { atom, useAtom } from "jotai";

export const toastInitAtom = atom(null);

export const useToast = () => {
  const [toastRef, setToastRef] = useAtom(toastInitAtom);

  return { toastRef, setToastRef };
};
